<!--div {{version}} {{skin.theme_color}}--><router-view></router-view>